export const languageData = "language=en-US"